import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100 mt20",
  style: {}
}
const _hoisted_2 = {
  key: 0,
  class: "fw600"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "fl" }, "候補の表示間隔 ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "selectTableView w100 mt10"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "header_title fs14 mt" }, "カスタム設定", -1)
const _hoisted_9 = { class: "text-left" }
const _hoisted_10 = { class: "customWeekButtons" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", {
  class: "fl mt16 mr15",
  style: {}
}, " 開始", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconHelp = _resolveComponent("IconHelp")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_AvailableDaysOfWeeksTableCell = _resolveComponent("AvailableDaysOfWeeksTableCell")!
  const _component_WeekdayButtons = _resolveComponent("WeekdayButtons")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.defaultStepSizeTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!_ctx.hideTitle)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_2, [
                _hoisted_3,
                _createVNode(_component_IconHelp, {
                  width: 18,
                  class: "fl mr10",
                  tooltipText: `提案する日程候補の開始時刻を変更します。`,
                  style: {"margin-top":"-3px"}
                })
              ]))
            : _createCommentVNode("", true),
          _hoisted_4,
          _createVNode(_component_SelectTag, {
            name: "meeting_time",
            id: "select_meeting_time",
            class: "fl fs14 roundForm mt5",
            style: {"min-width":"130px","height":"50px"},
            options: _ctx.CalendarUtil.selectDisplayMeetingTimeArr.map(t => t.type),
            defaultOption: _ctx.defaultStepSizeTitle,
            onSelectValue: _ctx.selectMeetingTime
          }, null, 8, ["options", "defaultOption", "onSelectValue"]),
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    (_ctx.defaultStepSizeTitle == `カスタム`)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.Util.isPresent(_ctx.customAvailableStartTimes))
            ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customAvailableStartTimes, (dic, adowindex) => {
                  return (_openBlock(), _createBlock(_component_AvailableDaysOfWeeksTableCell, {
                    key: `${adowindex}`,
                    dayOfTheWeek: dic.wday,
                    startHour: `${Object.keys(dic.available_time)[0]}`,
                    startMin: `${Object.values(dic.available_time)[0][0]}`,
                    onDeleteAdow: _ctx.deleteAdow,
                    showDeleteButton: true
                  }, null, 8, ["dayOfTheWeek", "startHour", "startMin", "onDeleteAdow"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_WeekdayButtons, {
                dayOfTheWeek: _ctx.dayOfTheWeek,
                classes: `mr15`,
                canEditWeek: true,
                onUpdate: _ctx.selectWeek
              }, null, 8, ["dayOfTheWeek", "onUpdate"]),
              _hoisted_11,
              _hoisted_12,
              _createVNode(_component_SelectTag, {
                name: "meeting_start_time",
                id: "select_meeting_start_time",
                class: "fl fs14 roundForm noBorder",
                style: {"width":"90px","min-width":"00px","height":"50px"},
                options: _ctx.timeArray,
                defaultOption: _ctx.startTimeStr,
                onSelectValue: _ctx.selectMeetingStartTime
              }, null, 8, ["options", "defaultOption", "onSelectValue"]),
              _hoisted_13,
              _createElementVNode("p", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addAvailableStartTime && _ctx.addAvailableStartTime(...args))),
                class: "pointer centered circle_button skyblueBg fs16 fl",
                style: {"width":"80px","border-radius":"8px","padding":"11px 8px"}
              }, " 追加 "),
              _hoisted_14
            ]),
            _hoisted_15
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}